




























import { Vue, Component, Prop } from "@/shared/vuepack";
import HsaBankOnboardingFooter from "@/employee/components/shared/HsaBankOnboardingFooter.vue";
import TransferFunds from "@/employee/components/onboarding/balance-transfer/TransferFunds.vue";
import TrusteeToTrusteeTransferDetails from "@/employee/components/onboarding/balance-transfer/TrusteeToTrusteeTransferDetails.vue";
import TrusteeToTrusteeTransferFormDownload from "@/employee/components/onboarding/balance-transfer/TrusteeToTrusteeTransferFormDownload.vue";
import TrusteeToTrusteeTransferFinish from "@/employee/components/onboarding/balance-transfer/TrusteeToTrusteeTransferFinish.vue";
import RolloverDetails from "@/employee/components/onboarding/balance-transfer/RolloverDetails.vue";
import RolloverFormDownload from "@/employee/components/onboarding/balance-transfer/RolloverFormDownload.vue";
import RolloverFinish from "@/employee/components/onboarding/balance-transfer/RolloverFinish.vue";
import { BalanceTransferStep, BalanceTransferStepKey, balanceTransferStepKeyRing } from "@/shared/types";

@Component({
  components: {
    HsaBankOnboardingFooter,
    TransferFunds,
    TrusteeToTrusteeTransferDetails,
    TrusteeToTrusteeTransferFormDownload,
    TrusteeToTrusteeTransferFinish,
    RolloverDetails,
    RolloverFormDownload,
    RolloverFinish
  }
})
export default class BalanceTransfer extends Vue {

  @Prop()
  stepKey: BalanceTransferStepKey;

  get currentStep () {
    if (!this.stepKey) {
      return BalanceTransferStep.TransferFunds;
    }

    return balanceTransferStepKeyRing[this.stepKey];
  }

  get title () {
    switch (this.currentStep) {
      case BalanceTransferStep.TransferFunds:
        return "Transfer funds";
      case BalanceTransferStep.TrusteeToTrusteeTransferDetails:
      case BalanceTransferStep.TrusteeToTrusteeTransferFormDownload:
      case BalanceTransferStep.TrusteeToTrusteeTransferFinish:
        return "Trustee-to-trustee transfer";
      case BalanceTransferStep.RolloverTransferDetails:
      case BalanceTransferStep.RolloverTransferFormDownload:
      case BalanceTransferStep.RolloverTransferFinish:
        return "Rollover";
      default:
        return "";
    }
  }

  get isTransferFundsStep () {
    return this.currentStep === BalanceTransferStep.TransferFunds;
  }

  get isTrusteeToTrusteeTransferDetails () {
    return this.currentStep === BalanceTransferStep.TrusteeToTrusteeTransferDetails;
  }

  get isTrusteeToTrusteeTransferFormDownload () {
    return this.currentStep === BalanceTransferStep.TrusteeToTrusteeTransferFormDownload;
  }

  get isTrusteeToTrusteeTransferFinish () {
    return this.currentStep === BalanceTransferStep.TrusteeToTrusteeTransferFinish;
  }

  get isRolloverDetails () {
    return this.currentStep === BalanceTransferStep.RolloverTransferDetails;
  }

  get isRolloverFormDownload () {
    return this.currentStep === BalanceTransferStep.RolloverTransferFormDownload;
  }

  get isRolloverFinish () {
    return this.currentStep === BalanceTransferStep.RolloverTransferFinish;
  }
}
